import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, Hub } from 'aws-amplify';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './services/current-user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  title = 'Campus-VR';

  formFields = {
    signUp: {
      "custom:RPMAvatarURL":{
        placeholder: "Ready Player Me Avatar URL",
        label: "Ready Player Me Avatar",
        labelHidden: true
      }
    }
  }

  constructor(
    private router: Router, 
    public authenticator: AuthenticatorService,
    public currentUser: CurrentUserService) { }

  ngOnInit() : void {
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'signIn':
          this.router.navigate(['home']);
      }
    })
  }

  logout() {
    this.authenticator.signOut();
  }

  services = {
    async validateCustomSignUp(formData: Record<string, any>){

      if (formData["custom:RPMAvatarURL"]) {

        if (!environment.rpmAvatarUrlRegExp.test(formData["custom:RPMAvatarURL"])){
          return {
            "custom:RPMAvatarURL": "Invalid"
          }
        }

      }

    },
    async handleSignUp(formData: Record<string, any>){

      let { username, password, attributes } = formData;
      attributes["custom:institution_id"] = environment.signUpDefaultInstitutionId
      attributes["custom:AvatarSDKAvatarCode"] = environment.signUpDefaultAvatarSDKAvatarCode
      return Auth.signUp({
        username,
        password,
        attributes,
      })

    }
  }

}